import * as React from 'react';
export const bindCheckbox = (setFieldValue) => React.useCallback((e) => {
    setFieldValue(e.currentTarget.name, e.currentTarget.checked);
}, [setFieldValue]);
